import { ShopDto } from '@core/mappers/country/dtos/ShopDto';
import Shop from '@models/country/Shop';

export function transformShop(dto: ShopDto): Shop {
    return {
        id: dto.ShopId,
        comTradeId: dto.MarketingSourceId,
        name: dto.ShopName,
        isActive: dto.Active,
        address: dto.Address,
        city: dto.City,
        latitude: dto.Latitude,
        longitude: dto.Longitude,
        state: dto.State,
        openingHour: dto.OpeningHour,
        closingHour: dto.ClosingHour,
    };
}
